<!-- the context menu is deactivated because only Firefox supports it -->
<div style="display:none" type="context" id="viewerContextMenu">
  <div style="display:none" id="contextFirstPage"></div>
  <div style="display:none" id="contextLastPage"></div>
  <div style="display:none" id="contextPageRotateCw"></div>
  <div style="display:none" id="contextPageRotateCcw"></div>
</div>
